<script>
import Template from '{Template}/Admin/Pages/Admin/Reports/AllWallets.template'
import AppLayout from '@/Layouts/AdminLayout'
import Welcome from '@/Jetstream/Welcome'
import NavButtonLink from "@/Jetstream/NavButtonLink";
import NavLink from "@/Jetstream/NavLink";
import Badge from "@/Jetstream/Badge";
import SearchFilter from '@/Jetstream/SearchFilter'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import {string_cut} from "@/Functions/String";
import AdminReportsTab from "@/Components/Reports/AdminReportsTab";
import axios from 'axios';

export default Template({

    components: {
        Badge,
        NavLink,
        NavButtonLink,
        AppLayout,
        Welcome,
        SearchFilter,
        AdminReportsTab,
        },
    props: {
	allWallets: [],
        filters: Object,
	links: [Array, Object],
	currencies: [],	
    },
    data() {
        return {
            sending: false,
            form: {
                search: (this.filters && this.filters.search) || '',
                type: (this.filters && this.filters.type) || 'all',
            },
            allWallets: [],
            currencies: [],
	    lastPrices: {},            
        }
    },

        created() {
    this.getCurrencies();
           
    },


    computed: {
	        
markets: function () {
        const markets = this.$store.getters.getMarkets;
        if (markets.length === 0) {
            // If markets data is not available, fetch it
            this.$store.dispatch('fetchMarkets');
        } else {
            // Log all markets with their last price
            markets.forEach(market => {
                console.log(`${market.name}: ${market.last}`);
            });
        }
        return markets;
    },	    
},

    methods: {
 
      calculateSumByCurrency(currencySymbol) {
        let sum = 0;
        // Iterate through the wallets and sum the balances of wallets with the same currency
        this.allWallets.data.forEach(wallet => {
            if (wallet.currency && wallet.currency.symbol === currencySymbol) {
                sum += Math.abs(parseFloat(wallet.balance_in_wallet || 0));
                sum += Math.abs(parseFloat(wallet.balance_in_order || 0));
                sum += Math.abs(parseFloat(wallet.balance_in_withdraw || 0));
            }
        });
        return sum.toFixed(4);
    },


          



     




     selectCurrency(currency) {
      this.selectedCurrency = currency;

    },
    
    async getCurrencies() {
        try {
            if (this.allWallets && Array.isArray(this.allWallets.data) && this.allWallets.data.length > 0) {
                this.currencies = [...new Set(this.allWallets.data.map(wallet => wallet.currency.symbol))];
                
                if (this.currencies.length > 0) {
                    this.selectCurrency(this.currencies[0]);

		    this.currencies.forEach(currencySymbol => {
                       const walletDataForCurrency = this.allWallets.data.filter(wallet => wallet.currency.symbol === currencySymbol);
                   });


                }
            }
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    },

        logWalletData() {
        
    },

        format_string(string, limit) {
            return string_cut(string, limit);
        },
        

        calculateSum(wallet) {
            const sum =
                parseFloat(wallet.balance_in_wallet) +
                parseFloat(wallet.balance_in_order) +
                parseFloat(wallet.balance_in_withdraw);
            return sum.toFixed(4); // Adjust the number of decimal places as needed
        },

    },

    mounted() {
        
        this.logWalletData();
	this.$store.dispatch('fetchMarkets');	
    },


   watch: {

        'wallets.data': {
            deep: true
    },

       form: {
           handler: throttle(function () {
                this.getList()
            }, 150),
            deep: true,
      },
        '$route.query.page': 'fetchWallets',
}

});
</script>
